export const HTMLFormatRegex=/^\s*<.*>\s*$/

export const MDXFormatRegex=/^(?!<[^>]*$)(?!"[^"]*$).*$/